import { DATE_OPTIONS, DATE_FULL_OPTIONS } from '.'

const LocalDate = (date, showTime = false) => {
  return (
    new Date(date).toLocaleString('cs-CZ', showTime ? DATE_FULL_OPTIONS : DATE_OPTIONS)
  )
}

export default LocalDate
